import type { SVGProps } from 'react';
const SvgDetails = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#details_svg__a)">
      <path
        fill="currentColor"
        d="M12 3 2 21h20L12 3Zm1 5.92L18.6 19H13V8.92Zm-2 0V19H5.4L11 8.92Z"
      />
    </g>
    <defs>
      <clipPath id="details_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDetails;
